export default "__VITE_ASSET__mxye$J2f__"